<a
  *ngIf="isLink(item) && !isFunction(item.route)"
  [fragment]="item.fragment"
  [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
  [routerLink]="item.route"
  class="item"
  routerLinkActive="active"
  fxLayout="row"
  matRipple>
  <mat-icon
    *ngIf="level === 0"
    [icIcon]="item.icon"
    class="item-icon"
    fxFlex="none"></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
  <span
    *ngIf="item.badge"
    [ngClass]="[item.badge.bgClass, item.badge.textClass]"
    class="item-badge"
    fxFlex="none">
    {{ item.badge.value }}
  </span>
</a>

<div
  *ngIf="isLink(item) && isFunction(item.route)"
  class="item"
  (click)="item.route()"
  routerLinkActive="active"
  fxLayout="row"
  matRipple>
  <mat-icon
    *ngIf="level === 0"
    [icIcon]="item.icon"
    class="item-icon"
    fxFlex="none"></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
  <span
    *ngIf="item.badge"
    [ngClass]="[item.badge.bgClass, item.badge.textClass]"
    class="item-badge"
    fxFlex="none">
    {{ item.badge.value }}</span
  >
</div>

<ng-container *ngIf="isDropdown(item)">
  <div
    (click)="toggleOpen()"
    [class.active]="isOpen || isActive"
    [class.open]="isOpen"
    class="item"
    fxLayout="row"
    matRipple>
    <mat-icon
      *ngIf="level === 0"
      [icIcon]="item.icon"
      class="item-icon"
      fxFlex="none"></mat-icon>
    <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
    <span
      *ngIf="item.badge"
      [ngClass]="[item.badge.bgClass, item.badge.textClass]"
      class="item-badge"
      fxFlex="none">
      {{ item.badge.value }}</span
    >
    <mat-icon
      [icIcon]="icKeyboardArrowRight"
      class="item-dropdown-icon"
      fxFlex="none"></mat-icon>
  </div>

  <div [@dropdown]="isOpen" class="item-dropdown">
    <ng-container *ngFor="let subItem of item.children">
      <ng-container *ngIf="subItem.userRole.includes(userRole)">
        <vex-sidenav-item [item]="subItem" [level]="level + 1"></vex-sidenav-item>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<div
  *ngIf="isButton(item) && item.action == 'addJob'"
  (click)="makeAction(item.action)"
  class="item addJobMenuItem"
  fxLayout="row"
  matRipple
  routerLinkActive="active">
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
</div>

<div
  *ngIf="isButton(item) && item.action != 'addJob'"
  (click)="makeAction(item.action)"
  class="item"
  fxLayout="row"
  matRipple
  routerLinkActive="active">
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
</div>

<ng-container *ngIf="isSubheading(item)">
  <div class="subheading">{{ item.label | translate }}</div>
  <vex-sidenav-item
    *ngFor="let subItem of item.children"
    [item]="subItem"
    [level]="0"></vex-sidenav-item>
</ng-container>
